import { all, put, call, takeLatest } from "redux-saga/effects";

import { request } from "../../services/client";
import { ActionTypes } from "../constants/actions";
import { APIEndpoints } from "../constants";

export function* addSuperAdmin(action) {
  try {
    const { email, name } = action.payload;
    const response = yield call(request, APIEndpoints.ADD_SUPER_ADMIN, {
      method: "POST",
      payload: { email, name },
    });
    yield put({
      type: ActionTypes.ADD_SUPER_ADMIN_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.ADD_SUPER_ADMIN_FAILURE,
      payload: err.message,
    });
  }
}

export function* editSuperAdmin(action) {
  try {
    const { userId, email, name } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.EDIT_SUPER_ADMIN(userId),
      {
        method: "PUT",
        payload: { email, name },
      }
    );
    yield put({
      type: ActionTypes.EDIT_SUPER_ADMIN_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.EDIT_SUPER_ADMIN_FAILURE,
      payload: err.message,
    });
  }
}

export function* deleteSuperAdmin(action) {
  try {
    const { userId } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.DELETE_SUPER_ADMIN(userId),
      {
        method: "DELETE",
      }
    );
    yield put({
      type: ActionTypes.DELETE_SUPER_ADMIN_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.DELETE_SUPER_ADMIN_FAILURE,
      payload: err.message,
    });
  }
}

export function* getSuperadminList() {
  try {
    const response = yield call(request, APIEndpoints.GET_SUPERADMIN_LIST, {
      method: "GET",
    });
    yield put({
      type: ActionTypes.GET_SUPERADMIN_LIST_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_SUPERADMIN_LIST_FAILURE,
      payload: err.message,
    });
  }
}

export function* getSuperadmin(action) {
  try {
    const { userId } = action.payload;
    const response = yield call(request, APIEndpoints.GET_SUPERADMIN(userId), {
      method: "GET",
    });
    yield put({
      type: ActionTypes.GET_SUPERADMIN_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_SUPERADMIN_FAILURE,
      payload: err.message,
    });
  }
}

export function* updateCompanySubscription(action) {
  try {
    const { companyId, data } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.UPDATE_COMPANY_SUBSCRIPTION(companyId),
      {
        method: "PUT",
        payload: data,
      }
    );
    yield put({
      type: ActionTypes.UPDATE_COMPANY_SUBSCRIPTION_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.UPDATE_COMPANY_SUBSCRIPTION_FAILURE,
      payload: err.message,
    });
  }
}

export function* createBusinessAdmin(action) {
  try {
    const { companyId, data } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.CREATE_BUSINESS_ADMIN(companyId),
      {
        method: "POST",
        payload: data,
      }
    );
    yield put({
      type: ActionTypes.CREATE_BUSINESS_ADMIN_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.CREATE_BUSINESS_ADMIN_FAILURE,
      payload: err.message,
    });
  }
}

export function* updateBusinessAdminStatus(action) {
  try {
    const requestData = action.payload;
    const response = yield call(
      request,
      APIEndpoints.UPDATE_BUSINESS_ADMIN_STATUS(requestData.userId),
      {
        method: "PUT",
        payload: { status: requestData.status },
      }
    );
    yield put({
      type: ActionTypes.UPDATE_BUSINESS_ADMIN_STATUS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.UPDATE_BUSINESS_ADMIN_STATUS_FAILURE,
      payload: err,
    });
  }
}

export function* createSubscriptionPlan(action) {
  try {
    const { companyId, subscriptionId, duration, data } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.CREATE_SUBSCRIPTION_PLAN(
        companyId,
        subscriptionId,
        duration
      ),
      {
        method: "POST",
        payload: data,
      }
    );
    yield put({
      type: ActionTypes.CREATE_SUBSCRIPTION_PLAN_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.CREATE_SUBSCRIPTION_PLAN_FAILURE,
      payload: err.message,
    });
  }
}

export function* getSubscriptionDetailsSuperadmin(action) {
  try {
    const response = yield call(
      request,
      APIEndpoints.GET_SUBSCRIPTION_DETAILS_SUPERADMIN,
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.GET_SUBSCRIPTION_DETAILS_SUPERADMIN_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_SUBSCRIPTION_DETAILS_SUPERADMIN_FAILURE,
      payload: err.message,
    });
  }
}

export function* getAllSubscriptionPlansSuperadmin(action) {
  const { companyId } = action.payload;

  try {
    const response = yield call(
      request,
      APIEndpoints.GET_ALL_SUBSCRIPTION_PLANS_SUPERADMIN(companyId),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.GET_ALL_SUBSCRIPTION_PLANS_SUPERADMIN_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_ALL_SUBSCRIPTION_PLANS_SUPERADMIN_FAILURE,
      payload: err.message,
    });
  }
}

export function* getSuperAdminReport(action) {
  try {
    const { companyId, year, country, facility } = action.payload;
    const data = {};
    if (year) data.year = year;
    if (country) data.country = country;
    if (facility) data.facility = facility;
    const response = yield call(
      request,
      APIEndpoints.GET_SUPER_ADMIN_REPORT(companyId),
      {
        method: "POST",
        payload: data,
      }
    );
    yield put({
      type: ActionTypes.GET_SUPER_ADMIN_REPORT_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_SUPER_ADMIN_REPORT_FAILURE,
      payload: err.message,
    });
  }
}

export function* getSuperAdminOrganizationCountry(action) {
  try {
    const { companyId } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.GET_SUPER_ADMIN_ORGANIZATION_COUNTRY(companyId),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.GET_SUPER_ADMIN_ORGANIZATION_COUNTRY_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_SUPER_ADMIN_ORGANIZATION_COUNTRY_FAILURE,
      payload: err.message,
    });
  }
}

export function* getSuperadminTickets({ payload }) {
  try {
    const response = yield call(
      request,
      APIEndpoints.GET_SUPERADMIN_TICKETS(payload.payload),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.GET_SUPERADMIN_TICKETS_SUCCESS,
      payload: response.tickets,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_SUPERADMIN_TICKETS_FAILURE,
      payload: err,
    });
  }
}

export function* getSuperadminTicketDetails({ payload }) {
  try {
    const apiUrl = APIEndpoints.GET_SUPERADMIN_TICKET_DETAILS(payload.ticketId);
    const response = yield call(request, apiUrl, {
      method: "GET",
    });
    yield put({
      type: ActionTypes.GET_SUPERADMIN_TICKET_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_SUPERADMIN_TICKET_DETAILS_FAILURE,
      payload: err,
    });
  }
}

export function* addSuperadminResponse({ payload }) {
  try {
    const apiUrl = APIEndpoints.ADD_SUPERADMIN_RESPONSE(payload.ticketId);
    const response = yield call(request, apiUrl, {
      method: "POST",
      payload: {
        response: payload.response,
      },
    });
    yield put({
      type: ActionTypes.ADD_SUPERADMIN_RESPONSE_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.ADD_SUPERADMIN_RESPONSE_FAILURE,
      payload: err,
    });
  }
}

export function* closeSuperadminTicket({ payload }) {
  try {
    const apiUrl = APIEndpoints.CLOSE_SUPERADMIN_TICKET(payload.ticketId);
    const response = yield call(request, apiUrl, {
      method: "POST",
      payload,
    });
    yield put({
      type: ActionTypes.CLOSE_SUPERADMIN_TICKET_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.CLOSE_SUPERADMIN_TICKET_FAILURE,
      payload: err,
    });
  }
}

export function* getAdminReportDetails(action) {
  try {
    const { companyId, countryCode, facilityId, year } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.GET_ADMIN_REPORT_DETAILS(
        companyId,
        countryCode,
        facilityId,
        year
      ),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.GET_ADMIN_REPORT_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_ADMIN_REPORT_DETAILS_FAILURE,
      payload: err.message,
    });
  }
}

export function* generateAnnouncement(action) {
  try {
    const { requestData } = action.payload;
    const response = yield call(request, APIEndpoints.GENERATE_ANNOUNCEMENT, {
      method: "POST",
      payload: requestData,
    });
    yield put({
      type: ActionTypes.GENERATE_ANNOUNCEMENT_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GENERATE_ANNOUNCEMENT_FAILURE,
      payload: err.message,
    });
  }
}

export function* updateAnnouncement(action) {
  try {
    const { requestData } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.UPDATE_ANNOUNCEMENT(requestData.id),
      {
        method: "PUT",
        payload: requestData,
      }
    );
    yield put({
      type: ActionTypes.UPDATE_ANNOUNCEMENT_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.UPDATE_ANNOUNCEMENT_FAILURE,
      payload: err,
    });
  }
}

export function* getAnnouncement(action) {
  try {
    const { announcementId } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.GET_ANNOUNCEMENT(announcementId),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.GET_ANNOUNCEMENT_SUCCESS,
      payload: response.announcement,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_ANNOUNCEMENT_FAILURE,
      payload: err.message,
    });
  }
}

export function* listAnnouncement(action) {
  try {
    const response = yield call(request, APIEndpoints.LIST_ANNOUNCEMENT, {
      method: "GET",
    });
    yield put({
      type: ActionTypes.LIST_ANNOUNCEMENT_SUCCESS,
      payload: response.announcements,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.LIST_ANNOUNCEMENT_FAILURE,
      payload: err.message,
    });
  }
}

export function* generateBlockchainCertificate({ payload }) {
  try {
    const apiUrl = APIEndpoints.GENERATE_BLOCKCHAIN_CERTIFICATE;
    const response = yield call(request, apiUrl, {
      method: "POST",
      payload: payload,
    });
    yield put({
      type: ActionTypes.GENERATE_BLOCKCHAIN_CERTIFICATE_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GENERATE_BLOCKCHAIN_CERTIFICATE_FAILURE,
      payload: err,
    });
  }
}

export function* getNftList(action) {
  try {
    const response = yield call(request, APIEndpoints.GET_NFT_LIST, {
      method: "GET",
    });
    yield put({
      type: ActionTypes.GET_NFT_LIST_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_NFT_LIST_FAILURE,
      payload: err,
    });
  }
}
export function* getCountryFacilityAggregate(action) {
  try {
    const { companyId, countryCode, facilityId } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.GET_COUNTRY_FACILITY_AGGREGATE(
        companyId,
        countryCode,
        facilityId
      ),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.GET_COUNTRY_FACILITY_AGGREGATE_SUCCESS,
      payload: response.country_data,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_COUNTRY_FACILITY_AGGREGATE_FAILURE,
      payload: err.message,
    });
  }
}

export function* getNftDetails(action) {
  try {
    const response = yield call(
      request,
      APIEndpoints.GET_NFT_DETAILS(action.payload),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.GET_NFT_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_NFT_DETAILS_FAILURE,
      payload: err,
    });
  }
}
export function* getRoleBasedAggregate(action) {
  try {
    const { companyId, facilityId } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.GET_ROLE_BASED_AGGREGATE(companyId, facilityId),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.GET_ROLE_BASED_AGGREGATE_SUCCESS,
      payload: response.user_data,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_ROLE_BASED_AGGREGATE_FAILURE,
      payload: err.message,
    });
  }
}

export function* activateSubscriptionBySuperAdmin(action) {
  try {
    const { companyId, ticketId } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.ACTIVATE_SUBSCRIPTION_BY_SUPER_ADMIN(companyId, ticketId),
      {
        method: "POST",
        payload: {},
      }
    );
    yield put({
      type: ActionTypes.ACTIVATE_SUBSCRIPTION_BY_SUPER_ADMIN_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.ACTIVATE_SUBSCRIPTION_BY_SUPER_ADMIN_FAILURE,
      payload: err.message,
    });
  }
}

export function* superAdminSubscriptionUpdate(action) {
  try {
    const { companyId, updateAction } = action.payload;
    const formData = new FormData();
    const { note, year, selectedFiles, actionEffect } = action.payload;

    if (selectedFiles?.length) {
      selectedFiles.forEach((file) => {
        if (file.file instanceof File) {
          formData.append("file", file.file);
        }
      });
    }
    if (note) {
      formData.append("note", note);
    }
    if (year) {
      formData.append("no_of_years", year);
    }
    if (actionEffect) {
      formData.append("cancellation_type", actionEffect);
    }

    const response = yield call(
      request,
      APIEndpoints.SUPER_ADMIN_SUBSCRIPTION_UPDATE(companyId, updateAction),
      {
        method: "POST",
        isFormData: true,
        payload: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    yield put({
      type: ActionTypes.SUPER_ADMIN_SUBSCRIPTION_UPDATE_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SUPER_ADMIN_SUBSCRIPTION_UPDATE_FAILURE,
      payload: err.message,
    });
  }
}

export function* superAdminSubscriptionLogs(action) {
  try {
    const { companyId } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.SUPER_ADMIN_SUBSCRIPTION_LOGS(companyId),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.SUPER_ADMIN_SUBSCRIPTION_LOGS_SUCCESS,
      payload: response?.logs,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SUPER_ADMIN_SUBSCRIPTION_LOGS_FAILURE,
      payload: err.message,
    });
  }
}

export function* superAdminSubscriptionAttachements(action) {
  try {
    const { companyId, logId } = action.payload;
    const response = yield call(
      request,
      APIEndpoints.SUPER_ADMIN_SUBSCRIPTION_ATTACHMENTS(companyId, logId),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.SUPER_ADMIN_SUBSCRIPTION_ATTACHMENTS_SUCCESS,
      payload: response?.attachments,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SUPER_ADMIN_SUBSCRIPTION_ATTACHMENTS_FAILURE,
      payload: err.message,
    });
  }
}

export function* superAdminCompanyOverview(action) {
  try {
    const response = yield call(
      request,
      APIEndpoints.SUPER_ADMIN_COMPANY_OVERVIEW(),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.SUPER_ADMIN_COMPANY_OVERVIEW_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SUPER_ADMIN_COMPANY_OVERVIEW_FAILURE,
      payload: err.message,
    });
  }
}

export function* superAdminUserOverviewDetails(action) {
  const { statusType } = action.payload;
  try {
    const response = yield call(
      request,
      APIEndpoints.SUPER_ADMIN_USER_OVERVIEW_DETAILS(statusType),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.SUPER_ADMIN_USER_OVERVIEW_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SUPER_ADMIN_USER_OVERVIEW_DETAILS_FAILURE,
      payload: err.message,
    });
  }
}

export function* superAdminCompanyOverviewDetails(action) {
  const { statusType } = action.payload;

  try {
    const response = yield call(
      request,
      APIEndpoints.SUPER_ADMIN_COMPANY_OVERVIEW_DETAILS(statusType),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.SUPER_ADMIN_COMPANY_OVERVIEW_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SUPER_ADMIN_COMPANY_OVERVIEW_DETAILS_FAILURE,
      payload: err.message,
    });
  }
}

export function* companyUserFacilityDetails(action) {
  const { companyId, status } = action.payload;

  try {
    const response = yield call(
      request,
      APIEndpoints.COMPANY_USER_FACILITY_DETAILS(companyId, status),
      {
        method: "GET",
      }
    );
    yield put({
      type: ActionTypes.COMPANY_USER_FACILITY_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.COMPANY_USER_FACILITY_DETAILS_FAILURE,
      payload: err.message,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(ActionTypes.ADD_SUPER_ADMIN, addSuperAdmin),
    takeLatest(ActionTypes.EDIT_SUPER_ADMIN, editSuperAdmin),
    takeLatest(ActionTypes.DELETE_SUPER_ADMIN, deleteSuperAdmin),
    takeLatest(ActionTypes.GET_SUPERADMIN_LIST, getSuperadminList),
    takeLatest(ActionTypes.GET_SUPERADMIN, getSuperadmin),
    takeLatest(
      ActionTypes.UPDATE_COMPANY_SUBSCRIPTION,
      updateCompanySubscription
    ),
    takeLatest(ActionTypes.CREATE_BUSINESS_ADMIN, createBusinessAdmin),
    takeLatest(
      ActionTypes.UPDATE_BUSINESS_ADMIN_STATUS,
      updateBusinessAdminStatus
    ),
    takeLatest(ActionTypes.CREATE_SUBSCRIPTION_PLAN, createSubscriptionPlan),
    takeLatest(
      ActionTypes.GET_SUBSCRIPTION_DETAILS_SUPERADMIN,
      getSubscriptionDetailsSuperadmin
    ),
    takeLatest(
      ActionTypes.GET_ALL_SUBSCRIPTION_PLANS_SUPERADMIN,
      getAllSubscriptionPlansSuperadmin
    ),
    takeLatest(ActionTypes.GET_SUPER_ADMIN_REPORT, getSuperAdminReport),
    takeLatest(
      ActionTypes.GET_SUPER_ADMIN_ORGANIZATION_COUNTRY,
      getSuperAdminOrganizationCountry
    ),
    takeLatest(ActionTypes.GET_SUPERADMIN_TICKETS, getSuperadminTickets),
    takeLatest(
      ActionTypes.GET_SUPERADMIN_TICKET_DETAILS,
      getSuperadminTicketDetails
    ),
    takeLatest(ActionTypes.ADD_SUPERADMIN_RESPONSE, addSuperadminResponse),
    takeLatest(ActionTypes.CLOSE_SUPERADMIN_TICKET, closeSuperadminTicket),
    takeLatest(ActionTypes.GET_ADMIN_REPORT_DETAILS, getAdminReportDetails),
    takeLatest(ActionTypes.GENERATE_ANNOUNCEMENT, generateAnnouncement),
    takeLatest(ActionTypes.UPDATE_ANNOUNCEMENT, updateAnnouncement),
    takeLatest(ActionTypes.GET_ANNOUNCEMENT, getAnnouncement),
    takeLatest(ActionTypes.LIST_ANNOUNCEMENT, listAnnouncement),
    takeLatest(
      ActionTypes.GENERATE_BLOCKCHAIN_CERTIFICATE,
      generateBlockchainCertificate
    ),
    takeLatest(ActionTypes.GET_NFT_LIST, getNftList),
    takeLatest(ActionTypes.GET_NFT_DETAILS, getNftDetails),
    takeLatest(
      ActionTypes.GET_COUNTRY_FACILITY_AGGREGATE,
      getCountryFacilityAggregate
    ),
    takeLatest(ActionTypes.GET_ROLE_BASED_AGGREGATE, getRoleBasedAggregate),
    takeLatest(
      ActionTypes.ACTIVATE_SUBSCRIPTION_BY_SUPER_ADMIN,
      activateSubscriptionBySuperAdmin
    ),
    takeLatest(
      ActionTypes.SUPER_ADMIN_SUBSCRIPTION_UPDATE,
      superAdminSubscriptionUpdate
    ),
    takeLatest(
      ActionTypes.SUPER_ADMIN_SUBSCRIPTION_LOGS,
      superAdminSubscriptionLogs
    ),
    takeLatest(
      ActionTypes.SUPER_ADMIN_SUBSCRIPTION_ATTACHMENTS,
      superAdminSubscriptionAttachements
    ),
    takeLatest(
      ActionTypes.SUPER_ADMIN_COMPANY_OVERVIEW,
      superAdminCompanyOverview
    ),
    takeLatest(
      ActionTypes.SUPER_ADMIN_USER_OVERVIEW_DETAILS,
      superAdminUserOverviewDetails
    ),
    takeLatest(
      ActionTypes.SUPER_ADMIN_COMPANY_OVERVIEW_DETAILS,
      superAdminCompanyOverviewDetails
    ),
    takeLatest(
      ActionTypes.COMPANY_USER_FACILITY_DETAILS,
      companyUserFacilityDetails
    ),
  ]);
}
